import { cn } from '@/lib/utils'

interface TourFooterProps {
  children: React.ReactNode
  className?: string
}

export function TourFooter({ children, className }: TourFooterProps) {
  return <div className={cn('flex justify-end pt-2 border-t border-border/40', className)}>{children}</div>
}
